export const cartAside = () => {
  const cart = window.Carbon.Cart;
  const $cartAsideBackground = document.querySelector(
    ".cart-aside__background"
  );
  const $cartAside = $cartAsideBackground.querySelector("aside.cart-aside");
  if ($cartAside) {
    cart.setUpCartAside($cartAside);
    const $body = document.querySelector("body");

    const closeCartAside = (event) => {
      event.preventDefault();

      $body.classList.remove("overflow-y-hidden");
      $cartAsideBackground.classList.add("pointer-events-none");
      $cartAsideBackground.classList.remove("bg-black", "bg-opacity-40");
      $cartAside.classList.add("translate-x-full", "ponter-events-none");
    };

    $cartAsideBackground.addEventListener("click", (event) => {
      if (event.target == $cartAsideBackground) {
        closeCartAside(event);
      }
    });

    const $cartAsideClose = $cartAside.querySelector(".cart-aside__close");
    $cartAsideClose.addEventListener("click", (event) => {
      event.stopPropagation();
      closeCartAside(event);
    });
  }
};

export default cartAside;
